module.exports = __webpack_public_path__ + "static/media/custom-filtering.36e01cf8.svg";